import React from 'react';
import {gql} from "apollo-boost";
import client from '../../src/graphql/client';
import {get} from 'lodash';

import Icon from '../../src/assets/icons/newsletter-circle.svg';
import seoQuery from '../../src/graphql/queries/seo';
import contentBuilderQuery from '../../src/graphql/queries/content-builder';
import refactorHb from '../../src/data-restructure/multimedia/hero-banner';
import refactorHBCData from '../../src/data-restructure/multimedia/hero-banner-carousel';
import refactorBreadcrumbsData from '../../src/data-restructure/navigation/breadcrumbs/breadcrumbs';

// components
import FormContainer from '../../src/containers/Forms/FormContainer';
import Banner from '../../src/components/multimedia/Banner';
import BannerSlider from '../../src/components/multimedia/BannerSlider';

const ENewsRegistration = (props) => {
  const country = props.countryProps.countryCode === 'AU' ? "Australia" : "New Zealand";  
  const dealerTitle = process.browser && process.env.DEALER_SITE ? window.staticly.dealerData.name : "{{data.template.dealer.name}}"

  return (

    <>
      {props.heroBanner &&
        <Banner
          {...props.heroBanner}
          largePaddingTop={true}
        />
      }
      {props.heroBannerSlider &&
        <BannerSlider
          {...props.heroBannerSlider}
        />
      }
        <FormContainer
          icon={Icon}
          formId="enews"
          thankYouUrl="/enews-registration/thank-you"
          title="YOUR BEST ADVENTURE IS JUST A CLICK AWAY"
          text="Subscribe now to receive regular updates, product announcements, upcoming events, and special deals and promotions straight into your inbox"
          formItems={[
            {
              type: 'name',
              name: 'first_name',
              label: 'first_name',
              placeholder: 'First name*',
              required: true,
              errorText: 'This field is required'
            },
            {
              type: 'name',
              name: 'last_name',
              label: 'last_name',
              placeholder: 'Last name*',
              required: true,
              errorText: 'This field is required'
            },
            {
              type: 'email',
              name: 'email',
              label: 'email',
              placeholder: 'Email*',
              required: true,
              errorText: 'Please add a valid email address'
            },
            {
              type: 'checkbox',
              margin: 'none',
              name: 'privacy',
              label: `I have read and agree to ${process.env.DEALER_SITE ? `${dealerTitle}'s` : `Jayco ${country}`} <a href="/privacy" target="_blank">Privacy Policy</a>*`,
              required: true,
              errorText: 'This field is required'
            }
          ]}
        />
    </>
  )
}
  
ENewsRegistration.propTypes = {

}
  
ENewsRegistration.defaultProps = {

}

export async function getStaticProps() {
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE : process.env.COUNTRY_CODE;

  const GET_CB_DATA = gql`
    query GET_CB_DATA {
      pageBy(uri: "enews-registration?${countryCode.toLowerCase()}") {
        title
        seo {
          ${seoQuery}
        }
        acf_domains {
          assignedDomains
        }
        ${contentBuilderQuery()}
      }
    }
  `

  const result = await client.query({
    query: GET_CB_DATA,
  });

  const context = get(result, 'data.pageBy', {});
  const cbData = get(result, 'data.pageBy.acf_content_builder.contentBuilder', null);

  // Hero banner
  const hasBanner = get(cbData, '[0].fieldGroupName', '') === 'page_AcfContentBuilder_ContentBuilder_FcSingleHeroBanner';
  const heroBanner = hasBanner ? refactorHb(cbData[0]) : null;

  // Banner carousel
  const hasCarousel = get(cbData, '[0].fieldGroupName', '') === 'page_AcfContentBuilder_ContentBuilder_FcHeroBannerCarousel';
  const heroBannerCarousel = hasCarousel ? refactorHBCData(cbData[0]) : null;

  const assignedDomains = get(result, 'data.pageBy.acf_domains.assignedDomains', []); 

  return {
    props: {
      meta: {
        title: context ? context.title : null,
        seo: context ? context.seo : null,
        assignedDomains
      },
      breadcrumbs: await refactorBreadcrumbsData('/enews-registration', assignedDomains),
      heroBanner,
      countryCode,
      heroBannerCarousel,
      marginTop: true
    }
  }
}
  
export default ENewsRegistration